module.exports = __webpack_public_path__ + "static/media/S2N6-3.06978129.svg";